var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{style:(_vm.imageStyle),attrs:{"src":require(("@/../public/" + _vm.asset + "/logo.png"))}})])}
var staticRenderFns = []

export { render, staticRenderFns }